/** Find the nearest date that is greater than or equal to today, else
 fall back to the most recent past date. */
export default function getDefaultSelectedDate(
  dates: Array<string>,
  now: Date = new Date(),
): string | null {
  let today = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()),
  ).toISOString();
  let nearestFutureDate = null;
  let mostRecentPastDate = null;
  for (let date of dates) {
    if (date >= today) {
      if (nearestFutureDate == null || date < nearestFutureDate) {
        nearestFutureDate = date;
      }
    } else {
      if (mostRecentPastDate == null || date > mostRecentPastDate) {
        mostRecentPastDate = date;
      }
    }
  }
  return nearestFutureDate || mostRecentPastDate;
}

export function getDefaultSelectedDateFromDateObject(
  dates: Array<{ id: string; name: string }>,
  now: Date = new Date(),
) {
  let today = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()),
  ).toISOString();
  let nearestFutureDate = null;
  let mostRecentPastDate = null;
  for (let date of dates) {
    if (date.id >= today) {
      if (nearestFutureDate == null || date.id < nearestFutureDate.id) {
        nearestFutureDate = date;
      }
    } else {
      if (mostRecentPastDate == null || date.id > mostRecentPastDate.id) {
        mostRecentPastDate = date;
      }
    }
  }
  return nearestFutureDate || mostRecentPastDate;
}
